import { render } from "./AsSupportAuth.vue?vue&type=template&id=391aa6de&scoped=true&ts=true"
import script from "./AsSupportAuth.vue?vue&type=script&lang=ts"
export * from "./AsSupportAuth.vue?vue&type=script&lang=ts"

import "./AsSupportAuth.vue?vue&type=style&index=0&id=391aa6de&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391aa6de"]])

export default __exports__